module.exports = __webpack_public_path__ + "static/media/satelite3.b4a6fbc6.png";